import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Spinner from './components/Spinner';
import Topbar from './components/Topbar';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import Copyright from './components/Copyright';
import BackToTop from './components/BackToTop';
import WhatsAppButton from './components/WhatsAppButton';
import ScrollToTop from './components/ScrollToTop';


// Pages
import Home from './pages/Home';
import About from './pages/About';
import Contact from './pages/Contact';
import Service from './pages/Service';
import Product from './pages/Product';
import Team from './pages/Team';
import Testimonial from './pages/Testimonial';
import NotFound from './pages/NotFound';

function App() {
  useEffect(() => {
    // Hide spinner after page load
    const spinner = document.getElementById('spinner');
    if (spinner) {
      setTimeout(() => {
        spinner.classList.remove('show');
      }, 1);
    }
  }, []);

  return (
    <Router>
      <div className="App">
        <Spinner />
        {/* <Topbar /> */}
        <Navbar />
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/service" element={<Service />} />
          <Route path="/product" element={<Product />} />
          <Route path="/team" element={<Team />} />
          <Route path="/testimonial" element={<Testimonial />} />
          <Route path="/portfolio" element={<NotFound />} />
        </Routes>
        <Footer />
        {/* <Copyright /> */}
        {/* <BackToTop /> */}
        <WhatsAppButton />
      </div>
    </Router>
  );
}

export default App;






